import { ToggleButtonGroup as MuiToggleButtonGroup } from '@mui/material';
import styled from 'styled-components';

export const ToggleButtonGroupStyled = styled(MuiToggleButtonGroup)`
    &.MuiToggleButtonGroup-root {
        border-radius: 8px;
    }

    .MuiToggleButton-root {
        border-color: ${(props) => props.theme.palette.primaryA4};
        color: ${(props) => props.theme.palette.textLight};
        ${(props) => props.theme.typography.smallTextBold};
        min-height: 44px;

        &.Mui-selected {
            border-color: ${(props) => props.theme.palette.primaryA1};
            background: transparent;
            color: ${(props) => props.theme.palette.primaryA1};

            &.Mui-disabled {
                color: ${(props) => props.theme.palette.primaryA1};
                border: 1px solid ${(props) => props.theme.palette.primaryA4};
                background-color: ${(props) => props.theme.palette.primaryA6};
            }

            &:not(.Mui-disabled) + .MuiToggleButton-root {
                border-left-color: ${(props) => props.theme.palette.primaryA1};
            }
        }
    }

    .Mui-disabled {
        background-color: ${(props) => props.theme.palette.primaryA6};
    }

    // .MuiFormLabel-root {
    //     ${(props) => props.theme.breakpointTo.sm} {
    //         transform: translate(12px, 12px) scale(1);
    //     }
    //
    //     &.Mui-focused {
    //         transform: translate(12px, 7px) scale(0.75);
    //     }
    // }

    // .MuiFormLabel-filled {
    //     transform: translate(12px, 7px) scale(0.75);
    // }
    //
    // .MuiFormHelperText-root {
    //     position: absolute;
    //     left: 0;
    //     width: max-content;
    //     ${(props) => props.theme.typography.smallTextBold}
    //     color: ${(props) => props.theme.palette.secondaryA4};
    //     bottom: -20px;
    // }

    // .MuiFormLabel-root.Mui-error {
    //     color: ${(props) => props.theme.palette.secondaryA4};
    // }

    &.Mui-error-container {
        border-color: ${(props) => props.theme.palette.secondaryA4};
    }
`;
